import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
    IonContent,
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonImg,
    IonModal,
    IonSearchbar,
    IonList,
    IonItem,
    IonLabel,
} from '@ionic/react';

import { colorTheme, OCCUPANT_TYPE, UNIFORM_RESOURCE_LOCATORS } from '../../utils/constants';
import { Col, Row } from 'reactstrap';
import { useSelector } from 'react-redux';

const Error404 = () => {
    const history = useHistory();
    const options = useSelector((state) => state.options);
    const [selectedPage, setSelectedPage] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const pages = [
        { label: 'Dashboard', value: UNIFORM_RESOURCE_LOCATORS.dashboard },
        { label: options.userAccountType === OCCUPANT_TYPE ? 'Tenants' : 'Members', value: UNIFORM_RESOURCE_LOCATORS.tenants },
        { label: 'Utilities', value: UNIFORM_RESOURCE_LOCATORS.utilities },
        { label: 'Properties', value: UNIFORM_RESOURCE_LOCATORS.properties },
        { label: 'Units', value: UNIFORM_RESOURCE_LOCATORS.units },
        { label: 'Payments', value: UNIFORM_RESOURCE_LOCATORS.payments },
        { label: 'Invoices', value: UNIFORM_RESOURCE_LOCATORS.invoices },
        { label: 'Team', value: UNIFORM_RESOURCE_LOCATORS.team },
        { label: 'Settings', value: UNIFORM_RESOURCE_LOCATORS.generalSettings },
        { label: 'Billing', value: UNIFORM_RESOURCE_LOCATORS.billing },
        { label: 'Alerts', value: UNIFORM_RESOURCE_LOCATORS.alertSettings },
    ];

    const filteredPages = pages.filter(p => p.label.toLowerCase().includes((searchTerm || '').toLowerCase()));

    const handlePageClick = (page) => {
        setSelectedPage(page.value);
        setIsOpen(false);
        setSearchTerm("");
        history.push(page.value);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle style={{ textAlign: "center"}}>Error 404 - Page Not Found</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className='ion-padding'>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", margin: "2em" }}>
                    <IonImg
                        src="images/logos/BOMAHUT-purple.svg"
                        style={{ 'maxWidth':'200px', 'maxHeight': '75px', textAlign: "center"}}
                        alt="Bomahut Logo"
                        className="ion-margin"
                    />
                    <h1 style={{ color: colorTheme["primary"]["700"], fontWeight: "bold" }}>BOMAHUT. Property Management bila stress..</h1>
                </div>
                {/* Searchable page selection */}
                <Row className='mx-1 my-2' style={{ display: "flex", justifyContent: "center" }}>
                    <Col xs={6} lg={6} className=''>
                        <div
                            onClick={() => setIsOpen(true)}
                            style={{ borderColor: colorTheme["primary"]["700"], border: "2px solid grey", borderRadius: "10px", padding: "12px", cursor: "pointer", textAlign: "center" }}
                        >
                            <span>{selectedPage ? pages.find(p => p.value === selectedPage)?.label : 'Select page you were looking for'}</span>
                        </div>

                        <IonModal isOpen={isOpen} onDidDismiss={() => setIsOpen(false)}>
                            <IonHeader>
                                <IonToolbar>
                                    <IonTitle>Select Page</IonTitle>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent>
                                <div className='px-3 py-2'>
                                    <IonSearchbar
                                        value={searchTerm}
                                        debounce={150}
                                        placeholder='Search pages'
                                        onIonInput={(e) => setSearchTerm(e.detail.value)}
                                    />
                                </div>
                                <IonList>
                                    {filteredPages.map((page) => (
                                        <IonItem key={page.value} button onClick={() => handlePageClick(page)}>
                                            <IonLabel>{page.label}</IonLabel>
                                        </IonItem>
                                    ))}
                                </IonList>
                            </IonContent>
                        </IonModal>
                    </Col>
                </Row>
                <div className="my-5" style={{ color: colorTheme["primary"]["700"], textAlign: "center", textDecoration: "underline" }}>
                    <Link to={UNIFORM_RESOURCE_LOCATORS.dashboard}>
                        Back to Home
                    </Link>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Error404;
